import { type Schemas } from "@/types";
import { Badge, Box, Flex, SimpleGrid, Stack, Text } from "@mantine/core";

import classes from "../..//Home.module.css";
import { IconDots } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { lowerCaseNthLetter } from "@/utils/filters";
import { useNavigate } from "react-router-dom";
import { getEnumTransKey } from "@/utils/trans";

interface AppointmentItemProps {
  appointment: Schemas["AppointmentRetrieveDto"];
}

export default function AppointmentItem({ appointment }: AppointmentItemProps) {
  const { t } = useTranslation("features");
  const navigate = useNavigate();
  const appointmentName =
    appointment.lead?.fullName ?? appointment.contact?.fullName ?? "";
  return (
    <Box
      className={classes.listItem}
      onClick={() => {
        navigate(`/app/leads/${appointment.lead?.id}/find-need`);
      }}
    >
      <Flex justify="space-between" align="center" direction="row" mb={4}>
        <Flex justify="flex-start" align="center" direction="row" gap={8}>
          <Text className={classes.listItemTitle}>{appointmentName}</Text>
          <Badge variant="light">
            {t(
              `appointments.${lowerCaseNthLetter(appointment.appointmentType!)}`,
            )}
          </Badge>
        </Flex>
        <IconDots width={20} height={20} style={{ display: "none" }} />
      </Flex>
      <SimpleGrid cols={{ xs: 2, sm: 2, md: 3, lg: 6, xl: 6 }} spacing={8}>
        <Stack gap={0}>
          <Text className={classes.listItemLabel}>
            {t(`appointments.meetingTime`)}
          </Text>
          <Text className={classes.listItemText}>
            {`
            ${new Date(appointment.startDate!).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })} -
            ${new Date(appointment.endDate!).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
        `}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text className={classes.listItemLabel}>
            {t(`appointments.businessUnit`)}
          </Text>
          <Text className={classes.listItemText}>
            {appointment.businessUnit?.code ?? ""}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text className={classes.listItemLabel}>{t(`leads.mobile`)}</Text>
          <Text className={classes.listItemText}>
            {appointment.lead?.mobile ?? ""}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text className={classes.listItemLabel}>
            {t(`appointments.appointmentStatus`)}
          </Text>
          <Text className={classes.listItemText}>
            {t(
              getEnumTransKey(
                "appointments",
                appointment?.appointmentStatus ?? "",
              ),
            )}
          </Text>
        </Stack>
      </SimpleGrid>
    </Box>
  );
}
